import * as ngCore from '@angular/core'

import { Store } from '../store'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  selector: 'atn-summit-org-chart-graph',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.AfterViewInit {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** {@link HTMLElement} which should contain the {@link cytoscape} graph */
  private readonly _containerElementRefSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('container')

  /**
   * Effect that binds {@link orgChartSg} to {@link _containerElementSg}
   *
   * @see {@link Manager.bind}
   */
  public ngAfterViewInit(): void {
    const container = this._containerElementRefSg()?.nativeElement
    const orgChartId = this.store.orgChartIdSg()
    if (container && orgChartId) {
      this.store.orgChartFeature.actions.bind
        .from('OrgChartGraph.ngAfterViewInit')
        .dispatch({ container: () => container, orgChartId })
    }
  }
}
